import { render } from "./loadErrorCorrection.vue?vue&type=template&id=5c4baf9e"
import script from "./loadErrorCorrection.vue?vue&type=script&lang=ts"
export * from "./loadErrorCorrection.vue?vue&type=script&lang=ts"
script.render = render

export default script